import {
  Activities,
  Card,
  DisplayText,
  ESpacings,
} from "@rentiohq/web-shared/dist/components";
import { ts } from "../../../../../services";
import * as documentPackageUtils from "../../../../../utils/documentPackage.utils";
import { IDocumentPackageTabProps } from "../DocumentPackage.types";

export const DocumentPackageHistory = (props: IDocumentPackageTabProps) => {
  const { documentPackage } = props;

  return (
    <Card
      space={ESpacings.base}
      heading={
        <DisplayText size="extraSmall" space="tight">
          {ts.system("history")}
        </DisplayText>
      }
    >
      <Activities
        identifier={`document-package-${documentPackage.id}`}
        filter={documentPackageUtils.getDocumentPackageActivityFilter({
          documentPackage,
        })}
        hasFetchMore={true}
        isCompact={true}
      />
    </Card>
  );
};
